import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import Icon from '../Icon/Icon';

import uploadPictureClasses from './UploadPicture.module.scss';

const handleResizeImage = (base64Str, maxWidth = 400, maxHeight = 350) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const MAX_WIDTH = maxWidth;
      const MAX_HEIGHT = maxHeight;
      let { width, height } = img;

      let shouldResize = false;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
          shouldResize = true;
        }
      } else if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
        shouldResize = true;
      }
      if (shouldResize) {
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', 0.9));
      } else {
        resolve(base64Str);
      }
    };
  });
};
export default function UploadPicture({
  className,
  inputFilePicture,
  setInputFilePicture,
}) {
  const cs = cx(uploadPictureClasses.imgContainer, className);
  const inputFileRef = useRef(null);
  const [imageResizedUrl, setImageResizedUrl] = useState(inputFilePicture);

  const handleChange = (e) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      handleResizeImage(event.target.result, 250, 250).then((result) => {
        setImageResizedUrl(result);
        setInputFilePicture(result);
      });
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  useEffect(() => {
    if (inputFilePicture !== undefined) {
      if (inputFilePicture.indexOf('http') > -1) {
        setImageResizedUrl(inputFilePicture);
      } else {
        handleResizeImage();
      }
    }
  }, [inputFilePicture, imageResizedUrl]);

  const onImageClick = () => {
    inputFileRef.current.click();
  };

  return (
    <>
      <input
        accept="image/*"
        style={{ display: 'none' }}
        id="button-image-file"
        type="file"
        onChange={(e) => handleChange(e)}
        ref={inputFileRef}
      />
      <button
        onClick={(e) => onImageClick(e)}
        className={uploadPictureClasses.button}
        type="button"
      >
        <div
          className={cs}
          style={{
            backgroundImage: `url(${imageResizedUrl}), url("/img/placeholders/avatar_placeholder.png")`,
            backgroundSize: 'cover',
          }}
        >
          <Icon
            icon={faPencil}
            size="1x"
            className={uploadPictureClasses.icon}
          />
        </div>
      </button>
    </>
  );
}

UploadPicture.propTypes = {
  className: PropTypes.string,
  inputFilePicture: PropTypes.any,
  setInputFilePicture: PropTypes.func,
};
